module.exports = __webpack_public_path__ + "static/media/gabinets.c1759611.svg";